module.exports = require("highcharts");